import { FC, useState } from 'react'

import { APP } from 'src/Configs/App'
import { InfluencerRegisterEnum } from 'src/Types/users'
import TiktokIcon from 'src/Assets/Svg/tiktok.svg?react'

import { TikTokBtnLink } from '../../styles'

interface LoginCreatorConnectProps {
  status: InfluencerRegisterEnum
}

export const LoginCreatorConnect: FC<LoginCreatorConnectProps> = ({
  status,
}) => {
  const [isConnecting, setIsConnecting] = useState(false)
  if (status !== InfluencerRegisterEnum.CONNECT) {
    return null
  }
  return (
    <TikTokBtnLink
      isConnecting={isConnecting}
      href={APP.TIKTOK_AUTH_API}
      onClick={() => setIsConnecting(true)}
    >
      <TiktokIcon />

      {isConnecting ? 'Connecting...' : 'Connect with TikTok'}
    </TikTokBtnLink>
  )
}
